<template>
    <AcceptDeclineComp></AcceptDeclineComp>
  </template>
  <script>
  import AcceptDeclineComp from "../../components/Case/AcceptDecline.vue";
  
  export default {
    name: "Case Confirmation",
    components: { AcceptDeclineComp },
    computed: {},
    mounted() {},
  };
  </script>
  